export default __webpack_public_path__ + "static/media/send.1d8c2f82.svg";